<template>
  <div>
    <div
      class="obstinate"
      v-show="
        prescripItem.prescripDrugsList &&
        prescripItem.prescripDrugsList.length > 3 &&
        ['1', '2', '4', '7'].includes(prescripItem.prescripType)
      "
      @click="allIn"
    >
      <span v-show="allInBool">显示全部</span>
      <span v-show="!allInBool">收起</span>
      <img
        :class="allInBool ? 'obstinateImg' : 'obstinateImgNone'"
        src="@funcPuzzle/mini_patient/next.png"
      />
    </div>
    <div class="pharmacist" v-if="prescripItem.drugUsageAdervise">
      <span class="pharmacistTitle">药师嘱托：</span>
      <span class="pharmacistName">
        {{ prescripItem.drugUsageAdervise || '- -' }}
      </span>
    </div>
    <div class="pharmacist">
      <span class="pharmacistTitle">处方编号：</span>
      <span class="pharmacistName">
        {{ prescripItem.prescripNum || '- -' }}
      </span>
    </div>
    <div class="pharmacist" v-if="prescripItem.state === '2'">
      <span class="pharmacistTitle">审核药师：</span>
      <span class="pharmacistName">
        {{ prescripItem.checkDoctorName || '- -' }}
      </span>
    </div>
    <div class="pharmacist">
      <span class="pharmacistTitle">医生：</span>
      <span class="pharmacistName">
        {{ prescripItem.doctorName || '- -' }}
      </span>
    </div>
    <div class="packagingPrice borderBottom">
      <span class="pharmacistTitle">总金额：</span>
      <div style="priceBox">
        <!-- 宁城中心医院煎药费是后面诊疗里面开，这里不展示 -->
        <span
          v-show="
            ['3', '5', '6'].includes(prescripItem.prescripType) && !['28770'].includes(hospitalID)
          "
          class="processCost font-s-24"
        >
          含煎药费￥{{ prescripItem.processCharge || 0 }}
        </span>
        <span class="priceName orange">¥ {{ pit(prescripItem.cost) }}</span>
      </div>
    </div>
    <!-- 配送费用0元时显示文案“到付” -->
    <!-- 已支付显示 -->
    <template v-if="String(prescripItem.payState) === '1'">
      <div class="packagingPrice borderBottom" v-if="String(prescripItem.dispendWay) === '2'">
        <span class="pharmacistTitle">配送费：</span>
        <span v-if="Number(deliveryFee)" class="pharmacistName marginLR20">¥{{ deliveryFee }}</span>
        <span v-else class="pharmacistName marginLR20">到付</span>
      </div>
      <!-- 医保支付：统筹+个人账户 -->
      <div class="packagingPrice borderBottom">
        <span class="pharmacistTitle">医保支付：</span>
        <span class="pharmacistName marginLR20">
          {{
            `- ¥ ${
              Number(prescripItem.medicalInsuranceCharge) +
                Number(prescripItem.medicalPersonalCharge) || `0.00`
            }`
          }}
        </span>
      </div>
      <div class="packagingPrice">
        <span class="pharmacistTitle">实付款：</span>
        <div style="priceBox">
          <!-- 到店支付使用 -->
          <span v-if="String(prescripItem.dispendWay) === '3'" class="priceName">到店付款</span>
          <span v-else class="priceName orange">
            ¥ {{ prescripItem.actualPayMent }}
            <!-- ¥ {{ prescripItem.personalCharge }} -->
          </span>
        </div>
      </div>
    </template>

    <!-- 已支付显示 end-->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    prescripItem: {
      type: Object,
      default: ''
    }
  },
  data() {
    return {
      allInBool: true
    }
  },
  computed: {
    ...mapState(['hospitalInfo']),
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    deliveryFee() {
      // 配送费
      return getKeyValueText('express_fee', this.hospitalID)
    }
  },
  mounted() {
    this.$emit('changeAllInBool', true)
  },
  methods: {
    pit(val) {
      if (val === undefined || val === null) {
        return ''
      }
      return val
    },
    allIn() {
      this.allInBool = !this.allInBool
      this.$emit('changeAllInBool', this.allInBool)
    }
  }
}
</script>

<style lang="scss" scoped>
.obstinate {
  margin: 20px auto;
  color: #222222;
  font-size: 30px;
  text-align: center;

  .obstinateImg {
    width: 30px;
    height: 30px;
    padding-left: 11px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    /* Internet Explorer 9*/
    -moz-transform: rotate(90deg);
    /* Firefox */
    -webkit-transform: rotate(90deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(90deg);
    /* Opera */
  }

  .obstinateImgNone {
    width: 30px;
    height: 30px;
    transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    /* Internet Explorer 9*/
    -moz-transform: rotate(-90deg);
    /* Firefox */
    -webkit-transform: rotate(-90deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(-90deg);
    /* Opera */
  }
}
.pharmacist {
  width: 100%;
  min-height: 94px;
  line-height: 94px;
  font-size: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;

  .pharmacistTitle {
    min-width: 100px;
    padding-left: 32px;
    color: #888888;
  }

  .pharmacistName {
    color: #222222;
    padding-right: 32px;
  }
}
.packagingPrice {
  width: 100%;
  height: 94px;
  line-height: 94px;
  display: flex;
  justify-content: space-between;

  .pharmacistTitle {
    font-size: 30px;
    padding-left: 32px;
    color: #888888;
  }

  .priceBox {
    display: flex;
    align-items: center;
    padding-right: 32px;

    .pharmacistText {
      display: inline-block;
      color: #222;
    }

    .processCost {
      display: inline-block;
      font-size: 24px;
      color: #222;
    }

    .priceName {
      display: inline-block;
      margin-left: 8px;
    }
  }
  .orange {
    color: #ff7555;
    font-weight: 500;
    font-size: 34px;
    padding-right: 20px;
    padding-left: 20px;
  }
  .marginLR20 {
    margin: 0 20px;
  }
}
.borderBottom {
  border-bottom: 1px solid #ececec;
}
</style>
